export type SearchBarKeywordSelection = {
    name: string;
    highlight?: string;
    category: string | undefined;
    categoryDisplayName: string | undefined;
    searchOptionsExactMatch?: boolean;
};

export type SearchBarKeywordState = {
    noSuggestions: boolean;
    selectedSuggestion: SearchBarKeywordSelection | undefined;
    suggestions: {
        name: string;
    }[];
    value: string;
    useRecentHistory: boolean;
    initialValue: string | undefined;
    suggestionsLatency: number | undefined;
};

export const defaultState: SearchBarKeywordState = {
    noSuggestions: false,
    selectedSuggestion: undefined,
    suggestions: [],
    value: '',
    useRecentHistory: false,
    initialValue: undefined,
    suggestionsLatency: undefined,
};

export default (state: SearchBarKeywordState = defaultState, action): SearchBarKeywordState => {
    switch (action.type) {
        case 'SET_SEARCH_BAR_KEYWORD_SUGGESTIONS':
            return Object.assign({}, state, {
                suggestions: action.suggestions,
                useRecentHistory: action.useRecentHistory,
            });
        case 'SET_SEARCH_BAR_KEYWORD_SUGGESTIONS_LATENCY':
            return Object.assign({}, state, {
                suggestionsLatency: action.suggestionsLatency,
            });
        case 'SELECT_SEARCH_BAR_KEYWORD_SUGGESTION':
            return Object.assign({}, state, {
                selectedSuggestion: action.suggestion,
            });
        case 'SET_INITIAL_SEARCH_BAR_KEYWORD':
            return Object.assign({}, state, {
                initialValue: action.keyword,
            });
        case 'SET_SEARCH_BAR_KEYWORD':
            return Object.assign({}, state, {
                value: action.keyword,
            });
        case 'NO_KEYWORD_SUGGESTIONS':
            return Object.assign({}, state, {
                noSuggestions: true,
            });
        default:
            return state;
    }
};
